export default __webpack_public_path__ + "static/media/sapiens.1fa853ed.png";